import { createContext, useContext } from "react";
import type { CallState, IncomingCallInfo } from "../hooks/useTwilioDevice";

export interface TwilioDeviceContextValue {
  deviceReady: boolean;
  callState: CallState;
  incomingCall: IncomingCallInfo | null;
  makeCall: (to: string, from: string, conversationId: string) => Promise<void>;
  acceptCall: () => void;
  rejectCall: () => void;
  hangup: () => void;
  toggleMute: () => void;
}

export const TwilioDeviceContext = createContext<TwilioDeviceContextValue | null>(null);

export function useTwilioDeviceContext(): TwilioDeviceContextValue {
  const ctx = useContext(TwilioDeviceContext);
  if (!ctx) {
    throw new Error("useTwilioDeviceContext must be used within a TwilioDeviceContext.Provider");
  }
  return ctx;
}
